module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-right/wow-fade-in-right.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-right/wow-fade-in-right.component.scss
// module chunks = main